import { render, staticRenderFns } from "./reform.vue?vue&type=template&id=18f299fe&scoped=true&"
import script from "./reform.vue?vue&type=script&lang=js&"
export * from "./reform.vue?vue&type=script&lang=js&"
import style0 from "./reform.vue?vue&type=style&index=0&id=18f299fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f299fe",
  null
  
)

export default component.exports